import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { FORMAT_WEEKDAY_DATE_MINI } from 'utils/helpers/datetime';
import { getDateObjectFromReservation } from 'utils/helpers/reservations';
import { getNextUpcomingReservation } from 'redux/selectors/current_booking';
import View from './view';

const Experience = () => {
  const upcomingReservation = useSelector(getNextUpcomingReservation);
  const name = upcomingReservation.selection_name;
  const reservationDate = getDateObjectFromReservation(upcomingReservation);
  const date = format(reservationDate, FORMAT_WEEKDAY_DATE_MINI);

  return <View name={name} date={date} />;
};

export default Experience;
